import {Injectable, isDevMode} from '@angular/core';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ProgressService {

    loadings: string[] = [];
    output: ReplaySubject<boolean> = new ReplaySubject<boolean>(0);

    constructor() {
    }

    startLoading(id: string): void {
        if (id.trim().length === 0) {
            throw new Error('Progres service needs id for startLoading(id)');
        }

        this.loadings.push(id.trim());
        this.output.next(true);
    }

    stopLoading(id: string): void {
        const index = this.loadings.indexOf(id.trim());

        if (index <= -1 && isDevMode()) {
            throw new Error(`Given id "${id}" not found in loadings`);
        }

        this.loadings.splice(index, 1);
        this.output.next(this.loadings.length > 0);
    }

    isLoading(): Observable<boolean> {
        // return this.loadings.length > 0;
        return this.output;
    }
}



// WEBPACK FOOTER //
// /app/src/services/progress.service.ts